const user_id = '131853218'
const project_id = '4735945'
const getAllVideosUrl = `/users/${user_id}/projects/${project_id}/videos`

export {getAllVideosUrl}